import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useParams } from "react-router";
import { BASE_API } from '../../api/Globals';
import { helpHttp } from '../../helpers/helpHttp';
import { Dialog } from 'primereact/dialog';
import { Steps } from 'primereact/steps';
import { SelectButton } from 'primereact/selectbutton';
import { Panel } from 'primereact/panel';
import { Button } from 'primereact/button';
import Menu from '../../components/sturtural/Menu';
import Loader from '../../components/sturtural/Loader';
import InputUpload from "../../components/sturtural/InputUpload";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import ScannerEntrega from './barcode';
import { Toast } from 'primereact/toast';
import TransaccionTablet from '../../components/dialogs/TransaccionTablet';
import { LABELTEXT } from '../../api/Globals';
import { storage } from '../../helpers/storage';

const MultientregaTablets = () => {

    const navigate = useNavigate();


    const [menusa, setMenusa] = useState(true);

    const [formTalla, setFormTalla] = useState(true);
    const [formIndentificacion, setFormIdentificacion] = useState(false);
    const [formFirma, setFormFirma] = useState(false);

    const [activeIndex, setActiveIndex] = useState(0);
    const [displayConfirmation, setDisplayConfirmation] = useState(false);
    const [confirm_cancelar, setConfirm_cancelar] = useState(false);


    const [aviso, setAviso] = useState(false);
    const [message, setMessage] = useState(null);
    const [displayDialogPendientes, setDisplaydialogPendientes] = useState(false);

    const [avisoe, setAvisoe] = useState(false);
    const [avisoBarcode, setAvisoBarcode] = useState(false);
    const [messagee, setMessagee] = useState(null);


    const [frontal, setFrontal] = useState(null);
    const [reverso, setReverso] = useState(null);
    const [comprobante, setComprobante] = useState(null);

    const [loading, setLoading] = useState(false);
    const [resumen, setResumen] = useState(false);

    const canvasRef = useRef(null);

    const [drawing, setDrawing] = useState(false);
    const ctxRef = useRef(null);

    const tienePendientes = localStorage.getItem('multientregaTabletsAlm')
    const [alumnosPendientes, setAlumnosPendientes] = useState([])

    const [alumno, setAlumno] = useState(null);
    const toast = useRef(null)


    const [Serie, setSerie] = useState(null);

    useEffect(() => {
        console.log(alumnosPendientes)
    }, [alumnosPendientes])


    const wizardItems = [
        {
            label: LABELTEXT,
            command: () => redirects(true, false, false)
        },
        {
            label: 'Identificación',
            command: () => redirects(false, true, false)
        },
        {
            label: 'Firma',
            command: () => redirects(false, false, true)
        }
    ];

    // Se activa el mensaje en caso de que no se tenga alumnos pendientes en el localStorage
    useEffect(() => {
        if (tienePendientes === null) {
            setDisplaydialogPendientes(true)
        } else {
            let pendientesParse = JSON.parse(tienePendientes)
            if (pendientesParse.length === 0) {
                setDisplaydialogPendientes(true)
            } else {
                let formater = pendientesParse.map((e) => {
                    let item = {
                        ...e,
                        Serie: ""
                    }
                    return item
                })
                setAlumnosPendientes(formater)
            }
        }
    }, [tienePendientes])

    const redirects = (talla, identificacion, firma) => {
        setFormTalla(talla);
        setFormIdentificacion(identificacion);
        setFormFirma(firma);
    }

    const handleClick_siguienteIdentificacion = () => {
        if (frontal && reverso) {
            setActiveIndex(2);
            setFormTalla(false);
            setFormIdentificacion(false);
            setFormFirma(true);

            document.body.style.overflow = "hidden";
        } else {
            setMessage('Favor de cargar las imágenes de su identificación');
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: 'Favor de cargar las imágenes de su identificación.', life: 3000 })
            setAviso(true);
        }
    }

    const handleClick_atrasIdentificacion = () => {
        setActiveIndex(1);
        setFormTalla(false);
        setFormIdentificacion(true);
        setFormFirma(false);

        document.body.style.overflow = "visible";
    }

    const handleSubmit_finalizar = () => {

        const transactionIdAlumno = alumnosPendientes.map(x => x.IdAlumno);
        const transactionIdEntrega = alumnosPendientes.map(x => x.IdEncEntrega);
        const idTutor = alumnosPendientes[alumnosPendientes.length - 1].IdTutor

        const lst = alumnosPendientes.map(x => x.DetEntrega)

        setMenusa(false);

        document.body.style.overflow = 'auto';
        const arrhologramas = {
            "IdEncEntrega": 0,
            "IdEncEntregaArray": transactionIdEntrega,
            "DetEntrega": lst,
            "IdUsuario": storage.get('id'),
            "FotoFrente": frontal.split(',')[1],
            "FotoReverso": reverso.split(',')[1],
            "FotoComprobante": (comprobante !== null ? comprobante.split(',')[1] : ''),
            "FotoFirma": getFirmaB64().split(',')[1],
            "FechaModificacion": "",
            "IdTutorSeleccionado": idTutor,
            "IdAlumno": 0,
            "IdEstatus": 2,
            "IdMotivoCancelacion": 0,
            "OtroMotivoCancelacion": "",
            "IdAlumnosArray": transactionIdAlumno,
            "JustificacionDeCancelacion": "",
            "IdTipoDocumento": 1,
            "IdDocumento": 1,
            "IsEntrega": true
        }

        console.log(arrhologramas)

        setLoading(true);


        helpHttp().post(`${BASE_API}Entrega/ConfirmarEntrega`, {
            body: arrhologramas,
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Access-Control-Allow-Origin': '*',
                'Authorization': `Bearer ${storage.get('token')}`
            },
        }).then((res) => {
            console.log('Resultado de entrgas', res)
            console.log(arrhologramas)
            console.log('esta es la Tranza:', transactionIdAlumno[0])
            if (res.SUCCESS === true) {
                setMessage('Uniforme entregado correctamente');
                setResumen(true);
                setAviso(true);
                navigate(`/resumen-alumno/${transactionIdAlumno[transactionIdAlumno.length - 1]}`)
            } else if (res.SUCCESS === false) {
                setMessage('(Error: 022) Error de conexión, Favor de iniciar el proceso nuevamente');
                setAviso(true);
            } else {
                setMessage('(Error: 021) Ocurrió un error al intentar realizar este proceso');
                setAviso(true);
            }

            localStorage.removeItem('transactionIdAlumno');
            localStorage.removeItem('transactionIdEntrega');
            localStorage.removeItem('transactionTallas');
            localStorage.removeItem('transactionFolio');
            localStorage.removeItem('multientregaTabletsAlm')

            setMenusa(true);
            setLoading(false);
            // navigate('/filtro/na')
        });
    }

    const handleClick_cancelar = () => {
        setConfirm_cancelar(true);
    }




    const handlerCancelarRedirect = () => {
        navigate('/pendientes-alumno');
        localStorage.removeItem('multientregaTabletsAlm');
    }

    const confirmationDialogFooter = (
        <>
            <div className="flex pt-3">
                <div className="w-6 pr-2">
                    {/* <button className="p-button p-component p-button-outlined p-button-secondary w-full p-button-icon-only" onClick={() => setConfirm_cancelar(false)}>
                        <span className="p-button-icon p-c pi pi-times-circle">&nbsp;NO</span>
                        <span className="p-button-label p-c">&nbsp;</span>
                    </button> */}
                    <Button className='p-button w-6' rounded label='SI'onClick={() => handlerCancelarRedirect()} />
                </div>
                <div className="w-6 pl-2">
                    {/* <button className="p-button p-component p-button-outlined p-button-secondary w-full p-button-icon-only" onClick={() => handlerCancelarRedirect()}>
                        <span className="p-button-icon p-c pi pi-check-circle">&nbsp;SI</span>
                        <span className="p-button-label p-c">&nbsp;</span>
                    </button> */}
                    <Button className='p-button-outlined w-6' rounded label='NO'onClick={() => setConfirm_cancelar(false)} />
                </div>
            </div>
        </>
    );

    const handleSelectionFrontal = base64 => {
        setFrontal(base64);
    }

    const handleSeleccionReverso = base64 => {
        setReverso(base64);
    }

    const handleSeleccionComprobante = base64 => {
        setComprobante(base64);
    }

    useEffect(() => {
        if (formFirma) {
            let width = window.innerWidth - 90;

            const canvas = canvasRef.current;
            // For supporting computers with higher screen densities, we double the screen density
            canvas.width = width * 2;
            canvas.height = 300 * 2;

            canvas.style.width = `${width}px`;
            canvas.style.height = `300px`;
            // Setting the context to enable us draw
            const ctx = canvas.getContext('2d');
            ctx.scale(2, 2);
            ctx.lineCap = 'round';
            ctx.strokeStyle = 'blue';
            ctx.lineWidth = 2;
            ctx.shadowBlur = 2 / 1;
            ctxRef.current = ctx;
        }
    }, [formFirma]);

    const getPositionOnCanvas = (event) => {
        const clientX = event.clientX || event.touches[0].clientX;
        const clientY = event.clientY || event.touches[0].clientY;
        const { offsetLeft, offsetTop } = event.target;
        const canvasX = clientX;
        const canvasY = clientY;
        const posicion = canvasRef.current.getBoundingClientRect();
        const nuevaPosicionX = canvasX - posicion.x;
        const nuevaPosicionY = canvasY - posicion.y;

        return { x: nuevaPosicionX, y: nuevaPosicionY };
    }

    const startDraw = ({ nativeEvent }) => {
        const position = getPositionOnCanvas(nativeEvent);
        ctxRef.current.beginPath();
        ctxRef.current.moveTo(position.x, position.y);
        setDrawing(true);
    };

    const stopDraw = () => {
        ctxRef.current.closePath();
        setDrawing(false);
    };

    const draw = ({ nativeEvent }) => {
        if (drawing) {
            const position = getPositionOnCanvas(nativeEvent);
            ctxRef.current.lineTo(position.x, position.y);
            ctxRef.current.stroke();
        }
    };

    const clear = () => {
        ctxRef.current.clearRect(
            0,
            0,
            canvasRef.current.width,
            canvasRef.current.height
        );
    };

    const getFirmaB64 = () => {
        return canvasRef.current?.toDataURL();
    }



    const firmaValida = () => {
        return canvasRef.current?.getContext('2d').getImageData(0, 0, canvasRef.current.width, canvasRef.current.height).data
            .some(channel => channel !== 0);
    }

    // const basicDialogFooter = <Button type="button" label="Aceptar" onClick={() => handlerRedirect(false)} icon="pi pi-check" className="p-button-secondary" />;

    const basicDialogFooter2 = <Button type="button" label="Aceptar2" onClick={console.log('redirect')} icon="pi pi-check" className="p-button-secondary" />;

    const basicDialogFoot = <Button type="button" on label="Cancelar" outlined icon="pi pi-times" onClick={() => { setAvisoBarcode(false); }} className="p-button" />;

    const mensajeOmicion = () => {
        setMessage("Has omitido la firma digital");
        setAviso(true);
    }

    const pendientesDialogFooter = () => {
        return (
            <React.Fragment>
                <Button label='Regresar' className='p-button' onClick={() => navigate('/pendientes-alumno')} />
            </React.Fragment>
        )
    }




    const escaneaBarcode = (alumno) => {
        setAvisoBarcode(true);
        setAlumno(alumno);
    }

    const EditTemplate = (alumno) => {
        return (
            <React.Fragment>
                <Button className='p-button' tooltip='Escanear tableta' rounded icon="pi pi-camera" onClick={() => escaneaBarcode(alumno)} />
                <Button className='p-button ml-4' tooltip='Remover tableta' rounded icon="pi pi-trash" onClick={() => removerSerieAlumno(alumno)} />
            </React.Fragment>
        )
    }

    const EditSerie = () => {
        return <label> {Serie} </label>
    }




    const onCellEditComplete = (e) => {
        let { rowData, newValue, field, originalEvent: event } = e;

        switch (field) {
            case 'TabletaAlm':
                if (newValue.trim().length > 0) rowData[field] = newValue;
                else event.preventDefault();
                break;

            default:
                if (newValue.trim().length > 0) rowData[field] = newValue;
                else event.preventDefault();
                break;
        }
    };

    const gradoGrupoTemplate = (alumno) => {
        return <label>{alumno.Grado}/{alumno.Grupo}</label>
    }

    const agregarSerieAlumno = (obj) => {
        let bandera = false
        alumnosPendientes.forEach(i => {
            if (i.Serie === obj.Serie) {
                bandera = true
            }
        });
        if (bandera !== true) {
            const arregloFormat = alumnosPendientes.map(item => {
                if (item.Curp === obj.Curp) {
                    item = obj
                }
                return item
            })
            setAlumnosPendientes(arregloFormat)
        } else {
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: 'Tableta escaneada anteriormente.', life: 5000 });
        }
    }

    const removerSerieAlumno = (obj) => {
        let bandera = false
        alumnosPendientes.forEach(i => {
            if (obj.Serie ==  "") {
                bandera = true
            }
        });
        console.log(bandera)
        if (bandera !== true) {
            const arregloFormat = alumnosPendientes.map(item => {
                if (item.Curp === obj.Curp) {
                    item.Serie = ""
                    delete item.DetEntrega
                }
                return item
            })
            setAlumnosPendientes(arregloFormat)
        } else {
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: 'Tableta sin registrar.', life: 5000 });
        }
    }

    const handleClick_siguienteTallas = () => {
        let bandera = false
        alumnosPendientes.forEach(x => {
            if (x.Serie === "") {
                bandera = true;
            }
        })

        if (bandera !== true) {
            setActiveIndex(1);
            setFormTalla(false);
            setFormIdentificacion(true);
            setFormFirma(false);
        } else {
            setMessage("Debe seleccionar el número de serie para todos los alumnos.");
            setAviso(true);
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: 'Debes capturar el número de serie del alumno.', life: 5000 })
        }
    }

    const handleClick_atrasTallas = () => {
        setActiveIndex(0);
        setFormTalla(true);
        setFormIdentificacion(false);
        setFormFirma(false);
    }


    const confirmationCancelarDialogFooter = (
        <>
            <div>
                <div>
                    {/* <button className="p-button p-component p-button-outlined p-button-secondary w-full p-button-icon-only" onClick={() => handlerCancelarRedirect()}>
                        <span className="p-button-icon p-c pi pi-check-circle">&nbsp;SI</span>
                        <span className="p-button-label p-c">&nbsp;</span>
                    </button> */}
                    <Button className='p-button-outlined' icon='pi pi-times' label='No' onClick={() => setConfirm_cancelar(false)} />

                    {/* <button className="p-button p-component p-button-outlined p-button-secondary w-full p-button-icon-only" onClick={() => setConfirm_cancelar(false)}>
                        <span className="p-button-icon p-c pi pi-times-circle">&nbsp;NO</span>
                        <span className="p-button-label p-c">&nbsp;</span>
                    </button> */}
                    <Button className='p-button' icon='pi pi-check' label='Sí' onClick={() => handlerCancelarRedirect()} />
                </div>
                
            </div>
        </>
    );

    return (
        <>
            <Toast ref={toast} />
            {menusa && <Menu link='nueva-solicitud' />}


            <div className="grid">
                <div className="col-12">
                    <div className="card">
                        <h2 style={{textAlign: 'center', marginBottom: '30px'}}>Entrega de tabletas </h2>
                        <Steps model={wizardItems} activeIndex={activeIndex} onSelect={(e) => setActiveIndex(e.index)} readOnly={true} /><br />
                    </div>
                </div>

                {formTalla &&
                    <div className="col-12">
                        <div className="card">
                            <h5>* Debe agregar el número de serie a todos los alumnos de la lista</h5>
                            <div className="px-4 py-3 surface-100 text-right">
                                <DataTable value={alumnosPendientes} dataKey='IdAlumno' editMode='cell' showGridlines>
                                    <Column field='Curp' header='CURP' bodyStyle={{ textAlign: 'center' }} alignHeader={'center'} />
                                    <Column field='NombreCompleto' header='Alumno' bodyStyle={{ textAlign: 'center' }} alignHeader={'center'} />
                                    <Column header='Grado/Grupo' body={gradoGrupoTemplate} bodyStyle={{ textAlign: 'center' }} alignHeader={'center'} />
                                    <Column field='Serie' header='No. serie' bodyStyle={{ textAlign: 'center' }} align={'center'} />
                                    <Column field='TabletaAlm' header='Acciones' body={EditTemplate} bodyStyle={{ textAlign: 'center' }} alignHeader={'center'} />
                                </DataTable>
                                <div className='mt-4'>
                                    <Button label="Cancelar" icon='pi pi-times' className="p-button-outlined p-button-rounded mr-2 mb-2" onClick={() => handleClick_cancelar()} />
                                    <Button label="Siguiente" icon='pi pi-arrow-circle-right' className="p-button-rounded mr-2 mb-2" onClick={() => handleClick_siguienteTallas()} />
                                </div>  
                            </div>
                        </div>
                    </div>}

                {formIndentificacion &&
                    <div className="col-12">
                        <div className="col-12 p-3">
                            <div className={`shadow-2 border-round surface-card mb-3 h-full flex-column justify-content-between flex`}>
                                <div className="p-4">
                                    <span className={`inline-flex border-circle align-items-center justify-content-center bg-gray-100 mr-3`} style={{ 'width': "48px", 'height': "48px", 'borderRadius': "10px" }}>
                                        <i className={`pi pi-camera text-xl text-gray-600`}></i>
                                    </span>
                                    <span className="text-900 font-medium text-2xl">
                                        <label style={{ color: 'red' }}>*&nbsp;</label>CAPTURA FRONTAL DE IDENTIFICACIÓN
                                    </span>
                                </div>

                                <div className='col-12'>
                                    <img
                                        style={{ 'display': 'block', 'width': '100%', 'height': '100%' }}
                                        id='base64image'
                                        src={frontal}>
                                    </img>
                                </div>

                                <div className="px-4 py-3 surface-100 text-right">
                                    <div className="input-group">
                                        <InputUpload
                                            usuarioid={storage.get('id')}
                                            handleSelection={handleSelectionFrontal} />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-12 p-3">
                            <div className={`shadow-2 border-round surface-card mb-3 h-full flex-column justify-content-between flex`}>
                                <div className="p-4">
                                    <span className={`inline-flex border-circle align-items-center justify-content-center bg-gray-100 mr-3`} style={{ 'width': "48px", 'height': "48px", 'borderRadius': "10px" }}>
                                        <i className={`pi pi-camera text-xl text-gray-600`}></i>
                                    </span>
                                    <span className="text-900 font-medium text-2xl">
                                        <label style={{ color: 'red' }}>*&nbsp;</label>CAPTURA REVERSO DE IDENTIFICACIÓN
                                    </span>
                                </div>

                                <div className='col-12'>
                                    <img
                                        style={{ 'display': 'block', 'width': '100%', 'height': '100%' }}
                                        id='base64image'
                                        src={reverso}>
                                    </img>
                                </div>

                                <div className="px-4 py-3 surface-100 text-right">
                                    <div className="input-group">
                                        <InputUpload
                                            usuarioid={storage.get('id')}
                                            handleSelection={handleSeleccionReverso} />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-12 p-3">
                            <div className={`shadow-2 border-round surface-card mb-3 h-full flex-column justify-content-between flex`}>
                                <div className="p-4">
                                    <span className={`inline-flex border-circle align-items-center justify-content-center bg-gray-100 mr-3`} style={{ 'width': "48px", 'height': "48px", 'borderRadius': "10px" }}>
                                        <i className={`pi pi-camera text-xl text-gray-600`}></i>
                                    </span>
                                    <span className="text-900 font-medium text-2xl">
                                    <label style={{ color: 'red' }}>*&nbsp;</label>CAPTURA COMPROBANTE
                                    </span>
                                </div>

                                <div className='col-12'>
                                    <img
                                        style={{ 'display': 'block', 'width': '100%', 'height': '100%' }}
                                        id='base64image'
                                        src={comprobante}>
                                    </img>
                                </div>

                                <div className="px-4 py-3 surface-100 text-right">
                                    <div className="input-group">
                                        <InputUpload
                                            usuarioid={storage.get('id')}
                                            handleSelection={handleSeleccionComprobante} />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-12">
                            <div style={{ right: '50px', bottom: '90px' }} className="px-4 py-3 surface-100 text-right">
                                <Button label="Atrás" icon='pi pi-arrow-circle-left' className="p-button-outlined p-button-rounded mr-2 mb-2" onClick={() => handleClick_atrasTallas()} />
                                <Button label="Siguiente" icon='pi pi-arrow-circle-right' className="p-button-rounded mr-2 mb-2" onClick={() => handleClick_siguienteIdentificacion()} />
                            </div>
                        </div>
                    </div>}

                {formFirma &&
                    <div className="col-12">
                        <div className="col-12  p-3">
                            <div className={`shadow-2 border-round surface-card mb-3 h-full flex-column justify-content-between flex`}>
                                <div className="p-4">
                                    <span className={`inline-flex border-circle align-items-center justify-content-center bg-gray-100 mr-3`} style={{ 'width': "48px", 'height': "48px", 'borderRadius': "10px" }}>
                                        <i className={`pi pi-pencil text-xl text-gray-600`}></i>
                                    </span>
                                    <span className="text-900 font-medium text-2xl">
                                        FIRMA DIGITAL
                                    </span>
                                </div>

                                <div className='col-12' style={{ 'height': "310px" }}>
                                    <canvas
                                        ref={canvasRef}
                                        id="drawing-area"
                                        onMouseDown={startDraw}
                                        onMouseUp={stopDraw}
                                        onMouseMove={draw}

                                        onTouchStart={startDraw}
                                        onTouchMove={draw}
                                        onTouchEnd={stopDraw}
                                        style={{ "border": "1px solid black" }}>
                                    </canvas>
                                </div>

                                <div className="px-4 py-3 surface-100 text-right">
                                    <Button label="Limpiar" className="p-button-rounded mr-2 mb-2" text severity='primary' onClick={() => clear()} />
                                    <Button label="Atrás" icon={'pi pi-arrow-circle-left'} className="p-button-outlined p-button-rounded mr-2 mb-2" onClick={() => handleClick_atrasIdentificacion()} />
                                    <Button label="Finalizar" disabled={loading} icon={(loading ? 'pi pi-spin pi-spinner' : 'pi pi-arrow-circle-right')} className="p-button-rounded mr-2 mb-2" onClick={() => firmaValida() ? handleSubmit_finalizar() : mensajeOmicion()} />
                                </div>
                            </div>
                        </div>
                    </div>}
            </div>

            <Dialog header="CONFIRMACIÓN" visible={displayConfirmation} onHide={() => setDisplayConfirmation(false)} style={{ width: '400px' }} modal className="p-fluid" footer={confirmationDialogFooter}>
                <div className="flex align-items-center justify-content-center">
                    <span>
                        ¿Cuenta con identificación oficial?
                    </span>
                </div>
            </Dialog>

            <Dialog header="Aviso de error" visible={avisoe} onHide={() => navigate("/pendientes-alumno")} style={{ width: '400px' }} modal className="p-fluid" footer={basicDialogFooter2}>
                <p>{messagee && messagee}</p>
            </Dialog>

            <Dialog header="CONFIRMACIÓN" visible={confirm_cancelar} closable={false} draggable={false} onHide={() => setConfirm_cancelar(false)} style={{ width: '400px' }} modal className="p-fluid" footer={confirmationCancelarDialogFooter}>
                <div className="flex align-items-center justify-content-center">
                    <label style={{textAlign: 'center', fontSize: '13px'}}>
                        <strong>¿Está seguro de cancelar la entrega?</strong><br />
                        <label>Cancelarás todas las entregas seleccionadas</label>
                    </label>
                </div>
            </Dialog>

            <Dialog visible={displayDialogPendientes} header={'AVISO'} style={{ width: '30%' }} modal footer={pendientesDialogFooter}>
                <div className='flex align-items-center justify-content-center'>
                    <span>
                        No tiene alumnos pendientes por entregar.
                    </span>
                </div>
            </Dialog>

            <Dialog header="BUSCAR TABLETA" draggable={false} visible={avisoBarcode} onHide={() => setAvisoBarcode(false)} style={{ width: '70%', height: '550px' }} modal closable={false} className="p-fluid" footer={basicDialogFoot}>
                <ScannerEntrega alumnoRow={alumno} onHide={() => { setAvisoBarcode(!avisoBarcode) }} onResult={(e) => { agregarSerieAlumno(e) }}  ></ScannerEntrega>
            </Dialog>
        </>
    )
}

export default MultientregaTablets;